<template>
  <div>
    <h1 class="unicorn-h1 mt-4">Архив заявок</h1>

    <div class="my-8 flex flex-col md:flex-row md:items-center">
      Выбор даты

      <u-date-picker
        class="md:ml-4 md:mt-0"
        v-model="date"
        :max-date="currentDate"
        title-position="left"
        :model-config="modelConfig"
      >
        <template v-slot="{ inputValue, inputEvents }">
          <u-button block v-on="inputEvents">
            {{ inputValue ? `${inputValue}` : "Выбор даты" }}
          </u-button>
        </template>
      </u-date-picker>
    </div>

    <div class="flex flex-col" v-if="learners.length">
      <template v-for="learner in learners">
        <ArchiveRequestEntry :learner="learner" :key="learner.id" />
        <u-divider :key="`divider_${learner.id}`" />
      </template>
    </div>

    <div class="px-4 my-4" v-else-if="error">
      <u-alert variant="danger" icon="mdi-alert">
        <template #title>
          Данные архива не загружены
        </template>

        <p>{{ errorText }}</p>

        <u-button class="mt-4" variant="secondary" text @click="reload">
          Повторить
        </u-button>
      </u-alert>
    </div>

    <div class="px-4 my-4" v-else>
      <u-alert icon="mdi-information-outline" variant="info">
        <p>
          Заявок на выбранный диапазон дат не найдено :( Попробуйте обновить
          страницу или изменить диапазон дат.
        </p>
      </u-alert>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { sortBy } from "lodash";
import Api from "../services/Api";

export default {
  data() {
    return {
      learners: [],

      date: "",
      currentDate: "",
      error: null,

      modelConfig: {
        type: "string",
        mask: "YYYY-MM-DD" // Uses 'iso' if missing
      }
    };
  },

  watch: {
    async date(date) {
      await this.loadArchive(this.classId, date);
    },

    async reloadToken() {
      await this.loadArchive(this.classId, this.date);
    }
  },

  computed: {
    ...mapState("connection", ["reloadToken"]),

    classId() {
      return this.$route.params.classId;
    },

    errorText() {
      const { kind } = Api.describeError(this.error);

      if (kind === "session") return "Сессия недействительна, войдите заново.";

      return "Нет связи со школьным сервером. Архив появится, как только связь восстановится.";
    }
  },

  created() {
    this.getDate();
  },

  methods: {
    reload() {
      this.$store.dispatch("connection/bumpReload");
    },

    /** Время школы — только для даты по умолчанию; при сбое берём время устройства. */
    async getDate() {
      let date = new Date();

      try {
        const { data: timestamps } = await Api.time();
        date = new Date(timestamps);
      } catch (error) {
        // Дата по устройству достаточно точна для выбора в календаре.
      }

      const stringDate = date
        .toLocaleDateString()
        .split(".")
        .reverse()
        .join("-");

      this.currentDate = stringDate;
      this.date = stringDate;
    },

    async loadArchive(classId, date) {
      if (!classId || !date) return;

      try {
        const { data: learners } = await Api.classes.getClassLearners(
          classId,
          date
        );
        this.learners = sortBy(learners, ["surname", "name"]);
        this.error = null;
      } catch (error) {
        this.error = error;
      }
    }
  }
};
</script>
